import AlertsTable from "./alerts-table.vue";

export default AlertsTable;



// WEBPACK FOOTER //
// ./src/components/_dashboard/alerts/table/index.js